import { Box } from '@mui/material';
import {
  DynamicPage,
  DynamicPageConfig,
  TemplateType,
} from 'compobot-dynamic-page';

interface DynamicPagePreviewProps {
  config?: DynamicPageConfig;
  theme?: TemplateType;
  currentLanguage?: string;
}

const DynamicPagePreview = ({
  config,
  theme = TemplateType.THEME_01,
  currentLanguage = 'en',
}: DynamicPagePreviewProps) => {
  // Don't render if no config is provided
  if (!config) {
    return (
      <Box
        width="400px"
        height="400px"
        display="flex"
        justifyContent="center"
        alignItems="center"
        borderRadius="50%"
        style={{
          backgroundColor: '#f5f5f5',
          border: '2px dashed #ccc',
        }}
      >
        <Box textAlign="center" color="text.secondary">
          Preview will appear here
        </Box>
      </Box>
    );
  }

  return (
    <Box
      width="400px"
      height="400px"
      display="flex"
      justifyContent="center"
      alignItems="center"
      borderRadius="50%"
      position="relative"
      style={{
        overflow: 'hidden',
      }}
    >
      <Box
        style={{
          transform: 'scale(0.5)',
          transformOrigin: 'center center',
          width: '800px', // Az eredeti DynamicPage mérete
          height: '800px', // Az eredeti DynamicPage mérete
        }}
      >
        <DynamicPage
          jsonConfig={config}
          theme={theme}
          currentLanguage={currentLanguage}
          onComplete={() => console.log('Page loaded')}
          pageDimensions={{
            dimensions: {
              width: '800px',
              height: '800px',
            },
          }}
        />
      </Box>
    </Box>
  );
};

export default DynamicPagePreview;
